import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    packageId: String,
    projectTitle: String
  }

  static targets = ["button", "resetButton"]

  connect() {
    this.isDownloading = false
    const token = new URL(window.location.href).searchParams.get("token")
    if (token) {
      const downloadUrl = new URL(this.buttonTarget.href)
      downloadUrl.searchParams.set("token", token)
      this.buttonTarget.href = downloadUrl.toString()
    }

    const downloadKey = `downloaded_${this.packageIdValue}`
    if (sessionStorage.getItem(downloadKey)) {
      this.#showDownloadRequested()
    }
  }

  handleDownload(event) {
    if (this.isDownloading) {
      event.preventDefault()
      return
    }

    this.isDownloading = true

    const downloadKey = `downloaded_${this.packageIdValue}`
    sessionStorage.setItem(downloadKey, "true")

    this.#showDownloadStarted()
  }

  resetDownload(event) {
    event.preventDefault()

    const downloadKey = `downloaded_${this.packageIdValue}`
    sessionStorage.removeItem(downloadKey)

    this.isDownloading = false
    this.#resetButton()
  }

  // Private

  #showDownloadStarted() {
    const button = this.buttonTarget
    const textSpan = button.querySelector("span")
    const icon = button.querySelector("i")

    button.classList.add("btn-disabled")
    button.setAttribute("aria-disabled", "true")

    if (textSpan) textSpan.textContent = "Starting download\u2026"
    if (icon) icon.className = "fadr fa-spinner-third fa-spin text-xl"

    // A click does not prove that the browser received the file.
    setTimeout(() => this.#showDownloadRequested(), 1500)
  }

  #showDownloadRequested() {
    const button = this.buttonTarget
    const textSpan = button.querySelector("span")
    const icon = button.querySelector("i")

    button.classList.add("btn-disabled")
    button.setAttribute("aria-disabled", "true")

    if (textSpan) textSpan.textContent = "Download requested"
    if (icon) icon.className = "fadr fa-circle-check text-xl"

    if (this.hasResetButtonTarget) {
      this.resetButtonTarget.classList.remove("hidden")
    }
  }

  #resetButton() {
    const button = this.buttonTarget
    const textSpan = button.querySelector("span")
    const icon = button.querySelector("i")

    button.classList.remove("btn-disabled")
    button.removeAttribute("aria-disabled")

    if (textSpan) textSpan.textContent = `Download ${this.projectTitleValue}`
    if (icon) icon.className = "fadr fa-download text-xl"

    if (this.hasResetButtonTarget) {
      this.resetButtonTarget.classList.add("hidden")
    }
  }
}
